<pq-header-nav></pq-header-nav>
<div class="container-fluid" id="page-content-wrapper">
  <router-outlet></router-outlet>
</div>
